import { getAccidentQuestions } from './accident'
import { getEmergencyContactQuestions } from './emergency-contact'
import { getEmployerQuestions } from './employer'
import { getInsuranceQuestions } from './insurance'
import { getPatientInformationQuestions } from './patient-information'
import { getPCPQuestions } from './pcp'
import { getWelcomeQuestions } from './welcome'

export * from './accident'
export * from './custom-questions'
export * from './emergency-contact'
export * from './employer'
export * from './insurance'
export * from './patient-information'
export * from './pcp'
export * from './welcome'

export const defaultQuestions = {
  accident: getAccidentQuestions,
  emergency: getEmergencyContactQuestions,
  employer: getEmployerQuestions,
  insurance: getInsuranceQuestions,
  contact: getPatientInformationQuestions,
  pcp: getPCPQuestions,
  welcome: getWelcomeQuestions,
}
